var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.iframe)?_c('div',{staticClass:"layout__wrap"},[_c('router-view',{key:_vm.key}),_c('SpeedDial')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }